import { httpsCallable } from '@firebase/functions';
import { getFunctions } from './getFunctions.ts';

export const getFunction = (name: string) => httpsCallable(getFunctions(), name);
